import { ClipboardList } from 'lucide-react';
import { Outlet } from 'react-router-dom';

/**
 * Plan pillar layout (route /plan) — SystemDox's standalone planning tool:
 * describe a feature and it drafts epics/issues grounded in the workspace's
 * docs and standards, then populates a GitHub Project board that hands off
 * to the agents on Connect.
 *
 * Header framing matches the other top-level pillars (see the Connect
 * pillar's BuildLayoutPage): centred title with the pillar glyph inline,
 * tagline underneath, no tab bar since Plan has a single view.
 */
export default function PlanLayoutPage() {
  return (
    <div className="p-8">
      <div className="mb-6 text-center">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100 flex items-center justify-center gap-2">
          <ClipboardList className="w-6 h-6 text-violet-600 dark:text-violet-400 shrink-0" />
          Plan
        </h1>
        <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
          Turn ideas into scoped, standards-aware implementation plans.
        </p>
      </div>
      <Outlet />
    </div>
  );
}
